import React, { useState } from "react";
import { Crown } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function Logo({ className = "", size = "md" }) {
  const { settings } = useApp();
  const [failed, setFailed] = useState(false);
  const logo = settings?.logo_url;
  const dim = size === "lg" ? "h-14" : size === "sm" ? "h-8" : "h-10";

  if (logo && !failed) {
    return <img src={logo} onError={() => setFailed(true)} alt="The King of Resell" className={`${dim} w-auto object-contain ${className}`} data-testid="brand-logo-img" />;
  }
  const iconSize = size === "lg" ? 34 : size === "sm" ? 20 : 26;
  const titleSize = size === "lg" ? "text-2xl" : size === "sm" ? "text-base" : "text-xl";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <span className="grid place-items-center rounded-full bg-gradient-to-br from-gold-200 to-gold-500 text-ink-900" style={{ width: iconSize + 14, height: iconSize + 14 }}>
        <Crown size={iconSize} strokeWidth={2.4} />
      </span>
      <div className="leading-none">
        <div className={`font-heading font-black tracking-tight ${titleSize} text-white`}>
          THE KING OF <span className="gold-gradient-text">RESELL</span>
        </div>
        <div className="overline-label mt-0.5">Football Challenge</div>
      </div>
    </div>
  );
}
